import SharedFormInput from '../shared/FormInput';

import {
  addMissingMandatoryField,
  removeMissingMandatoryField,
  addRemark,
  removeRemark,
  updateRemark,
  addFile,
  removeFile,
} from 'reducers/homePersonalFormReducer';

import type { MessageProps } from '../shared/Message/Message.types';

interface HomeFormInputProps {
  section: number;
  name: string;
  label?: string;
  type?: string;
  step?: string | number;
  helpText?: string;
  value?: any;
  onChange?: (event: any) => void;
  message?: Omit<MessageProps, 'section'> & { section?: number };
  required?: boolean;
  subLabel?: string;
  infoText?: string;
  disabled?: boolean;
}

const HomeFormInput = (props: HomeFormInputProps) => {
  const formActions = {
    addMissingMandatoryField,
    removeMissingMandatoryField,
    addRemark,
    removeRemark,
    updateRemark,
    addFile,
    removeFile,
  };

  return (
    <SharedFormInput
      {...props}
      formStateKey="homePersonalForm"
      formActions={formActions}
    />
  );
};

export default HomeFormInput;
